module.exports = __webpack_public_path__ + "img/footer-bottom.9f5e20ca.png";